import React, { Component } from 'react';
import serverClientUtil from '../../../../utils/serverClientUtil';
import NewItemInnerMainMenu from './NewItemInnerMainMenu';
import { closeModalIcon, logoMegaMenu } from '../svgIcons';

const layoutTypes = [
  'gridContainer1Columns',
  'gridContainer2Columns',
  'gridContainer3Columns',
  'gridContainer4Columns',
];

const tab = '\u00A0';

class NewInnerMainContainerMenu extends Component {
  render() {
    const { setSelectData, setAllBlurOverMegaMenu, data, selectData, allBlurOverMegaMenu, closeShowMenu } = this.props;
    const displayList = (selectData && selectData.children && selectData.children.slice(0, 8)) || [];
    const selectDataLength = displayList.length;

    const selectClassNameForGrid = (n) => {
      if (n >= 8) return 3;
      return (n % 2 === 0)
        ? (selectDataLength / 2) - 1
        : ((selectDataLength + 1) / 2) - 1;
    };

    return (
      <div className={'wrapDropdownMenu'} onMouseLeave={() => setSelectData({})}>
        <div
          className="close newWrapDropdownMenu"
          onClick={closeShowMenu}
        >
          {closeModalIcon}
        </div>
        <div
          className={`${'dropdownMenu'}`}
          onMouseEnter={() => setAllBlurOverMegaMenu(true)}
          onMouseLeave={() => setAllBlurOverMegaMenu(false)}
        >
          <div className="logoContainer">{logoMegaMenu}</div>
          {
            data?.l1Categories?.map(l1Category => {
              const item = l1Category.allMeta;
              return <a
                target="_blank"
                href={`${serverClientUtil.getLPURL()}${item?.viewUrl}`}
                key={item?.title}
                rel="noopener noreferrer"
                className={`dropItem dataChilds
                  ${allBlurOverMegaMenu && (selectData?.name === item?.title) ? 'childSelected' : ''} `}
                onMouseEnter={() => setSelectData(item)}
              >
                {item?.title}
                <span
                  className="chevron chevronLeft left chevronLeftInnerSubmenuWap arrowHidden"
                  style={{
                    marginTop: 0,
                    marginRight: 30,
                    color: '#0F4DBC', // TODO: dinamic brand!!
                  }}
                />
              </a>
            })
          }
        </div>
        {selectData && selectData?.title && (
          <div
            className={`${'dropdownMenuContent'} contentOfSubcategories`}
            onMouseEnter={() => setAllBlurOverMegaMenu(true)}
            onMouseLeave={() => setAllBlurOverMegaMenu(false)}
          >
            <div
              className={`${layoutTypes[selectClassNameForGrid(selectDataLength)]}`}
              style={{ marginBottom: '30px' }}
            >
              {displayList &&
                displayList.map(item => (
                  <NewItemInnerMainMenu key={JSON.stringify(item)} data={item} />
                ))}
            </div>

            <div className="showMoreLinkBtn">
              {selectDataLength === 8 && (
                <a
                  href={`${serverClientUtil.getLPURL()}${selectData?.url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    background: '#F18AD0', // TODO: Dinamic style brand
                  }}
                >
                  {' '}
                  Ver todas las secciones{tab}
                  <span className="chevron chevronLeft left chevronLeftInnerSubmenuWap" />
                </a>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default NewInnerMainContainerMenu;
